function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

function SvgDownload(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 22 20.69"
  }, props), React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, React.createElement("path", {
    d: "M21.5,13.19v4.32a2.68,2.68,0,0,1-2.67,2.68H3.17A2.68,2.68,0,0,1,.5,17.51V13.19",
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), React.createElement("line", {
    x1: 11,
    y1: 0.5,
    x2: 11,
    y2: 14.97,
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), React.createElement("polyline", {
    points: "6.71 10.68 11 14.97 15.29 10.68",
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}

export default __webpack_public_path__ + "static/media/download.6ba723bf.svg";
export { SvgDownload as ReactComponent };